export { default as Atmo } from "@/assets/vectors/icons/type-atmo.svg?inline";
export { default as Interview } from "@/assets/vectors/icons/type-interview.svg?inline";
export { default as OTon } from "@/assets/vectors/icons/type-oton.svg?inline";
export { default as Download } from "@/assets/vectors/icons/download.svg?inline";
export { default as Share } from "@/assets/vectors/icons/share.svg?inline";
export { default as Umfrage } from "@/assets/vectors/icons/type-survey.svg?inline";
export { default as More } from "@/assets/vectors/icons/more.svg?inline";
